import { render, staticRenderFns } from "./ModalPageSettingsContainer.vue?vue&type=template&id=7df71c30&scoped=true&"
import script from "./ModalPageSettingsContainer.vue?vue&type=script&lang=ts&"
export * from "./ModalPageSettingsContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df71c30",
  null
  
)

export default component.exports